import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Button from '../../../../components/Button';
import { Modules } from '../../../../enums';

const Header: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleGoToDashboardClick = () => {
    navigate(Modules.home);
  };

  return (
    <div className="row mb-6">
      <div className="col-6">
        <h4 className="m-0 fw-bold">{t('changePassword.pageTexts.header.title')}</h4>
        <p>{t('changePassword.pageTexts.header.subTitle')}</p>
      </div>
      <div className="col-6 d-flex align-items-center justify-content-end">
        <div className="add-new">
          <Button
            className="btn btn-primary waves-effect waves-light"
            onClick={handleGoToDashboardClick}
            text={t('changePassword.pageTexts.header.goToDashboardButton')}
          />
        </div>
      </div>
    </div>
  );
};

export default Header;
